//@flow
import React, {
  useState,
  createContext,
  useContext,
  useRef,
  useEffect, useCallback, useMemo,
} from 'react';
import {
  Grid,
  MuiThemeProvider,
  createMuiTheme,
  DialogTitle,
  DialogContent,
  DialogActions, Button, Typography,
} from '@material-ui/core';
import { Dialog } from '@reach/dialog';
import Header from './Header';
import ProductsList from './ProductsList';
import FilesDropzone, { getImageUrl } from '../FilesDropzone';
import { themeWithRtl } from 'src/theme';
import firebase from 'firebase/app';
import 'firebase/firestore';
import OpenningHours from './OpenningHours';
//import ContactInfo from './ContactInfo';
import Bio from './Bio';
import Coupon from './Coupon';
import styled, { ThemeProvider } from 'styled-components';
import ClubForm from './ClubForm';
import ProductsList2 from './ProductsList2';
import CouponForm from './CouponForm';
import Purchase from '../../views/Purchase';
import PurchaseButtons from './PurchaseButtons';
import ProductsList3 from './ProductsList3';
import { Field, Form } from 'formik';
import { FormikTextField } from '../FormikFields';
import PromoVideo from './PromoVideo';
import { useDispatch } from 'react-redux';
import {addToCart} from '../../actions'
import { useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom'

const BusinessCardContext = createContext();

export const useBusinessCard = () => useContext(BusinessCardContext);

function BusinessCard(props) {
  const [logoUri, setLogoUri] = useState('');
  const [avatarUri, setAvatarUri] = useState('');
  const [user, setUser] = useState({});
  const [showClubForm, setShowClubForm] = useState(false);
  const [showCoupon, setShowCoupon] = useState(false);
  const [showPromoMovie, setShowPromoMovie] = useState(false);
  const [backgroundImageUri, setBackgroundImageUri] = useState('');
  const [backgroundImageBottomUri, setBackgroundImageBottomUri] = useState('');
  const [couponImageUri, setCouponImageUri] = useState('');
  const [showComingSoon, setShowComingSoon] = useState(false);
  const cart = useSelector((state) => state.session.cart);
  const dispatch = useDispatch();
  const history = useHistory();
  const [dimensions, setDimensions] = useState({
    width: 0,
    height: 0,
    vh: () => 0,
    vw: () => 0,
  });

  useEffect(() => {
    if (props.user?.uid) {
      firebase
        .firestore()
        .collection('users')
        .doc(props.user.uid)
        .get()
        .then((doc) => {
          setUser({ ...doc.data(), plan: doc.data()?.plan || 'basic' });
        });
    }
  }, [props.user]);
  const containerRef = useRef();
  const [tab, setTab] = useState < 'idle' | 'openning-hours' | 'bio' > ('idle');

  const { backgroundImage, backgroundImageBottom, avatar, font, textColor, logo, designTemplate, couponImage } = props;

  useEffect(() => {
    if (containerRef) {
      const width = containerRef.current.clientWidth;
      const height = containerRef.current.clientHeight;
      setDimensions({
        width,
        height,
        vh: (y) => (height / 100) * y,
        vw: (x) => (width / 100) * x,
      });
    }
  }, [containerRef]);

  React.useEffect(() => {
    getImageUrl(logo).then(setLogoUri);
  }, [logo]);
  React.useEffect(() => {
    getImageUrl(avatar).then(setAvatarUri);
  }, [avatar]);
  React.useEffect(() => {
    getImageUrl(backgroundImage).then(setBackgroundImageUri);
  }, [backgroundImage]);
  React.useEffect(() => {
    getImageUrl(backgroundImageBottom).then(setBackgroundImageBottomUri);
  }, [backgroundImageBottom]);
  React.useEffect(() => {
    getImageUrl(couponImage).then(setCouponImageUri);
  }, [couponImage]);

  const cardTheme = createMuiTheme({
    ...themeWithRtl,

    typography: {
      allVariants: {
        color: textColor,
      },
      fontFamily: font,
      fontSize: 16,
      htmlFontSize: 16,
      color: textColor,
      h1: { fontSize: '1.75rem' },
      h2: { fontSize: '1.5rem' },
      h3: { fontSize: '1.25rem' },
      h4: { fontSize: '1rem' },
      h5: { fontSize: '0.75rem' },
    },
  });

  const renderComingSoonDialog = () => {
    return (
      <StyledDialog isOpen={showComingSoon} onDismiss={() => setShowComingSoon(false)}>
        <LighboxContainer>
          <LightboxHeader onClick={() => setShowComingSoon(false)}> אפשרות לתשלום </LightboxHeader>
          <LightboxDescription>
            בקרוב ...
          </LightboxDescription>
        </LighboxContainer>
      </StyledDialog>
    );
  };

  const onPurchase = () => {
    setShowComingSoon(true);
  };

  const addToCartAction = (item) => {
    dispatch(addToCart(item))
  }

  const getProductsList = () => {
    const { designTemplate } = props;
    switch (designTemplate) {
      case 'a':
        return <ProductsList onPurchase={onPurchase} addToCart={addToCartAction} />;
      case 'b':
        return <ProductsList2 onPurchase={onPurchase} addToCart={addToCartAction} />;
      case 'c':
        return <ProductsList3 onPurchase={onPurchase} addToCart={addToCartAction} />;
      default:
        return <ProductsList onPurchase={onPurchase} addToCart={addToCartAction} />;
    }
  };

  return (
    <BusinessCardContext.Provider
      value={{
        card: { ...props, avatarUri, logoUri, backgroundImageUri, backgroundImageBottomUri, couponImageUri },
        dimensions,
        tab,
        setTab,
        user,
      }}
    >
      <ThemeProvider
        theme={{
          ...props,
          'font-family': 'roboto' || props.font,
          dimensions,
        }}
      >
        <div
          ref={containerRef}
          style={{
            maxWidth: '100vw',
            flexGrow: 1,
            fontFamily: props.font,
            overflowX: 'hidden',
            overflowY: 'hidden',
            backgroundColor: props.backgroundColor,
            backgroundImage: `url(${backgroundImageBottomUri})`,
            backgroundSize: 'cover',
            backgroundRepeat: 'no-repeat',
            backgroundPosition: 'center',
          }}
        >
          <MuiThemeProvider theme={cardTheme}>
            <Header
              {...props}
              avatarUri={avatarUri}
              logoUri={logoUri}
              history={history}
              slug={props.slug}
              backgroundImageUri={backgroundImageUri}
              onClubClick={() => setShowClubForm(true)}
              onCouponClick={() => setShowCoupon(true)}
              cartItems={cart.reduce((prev, cur) => cur.count + prev , 0)}
              onPromoMovieClick={() => setShowPromoMovie(true)}
            />
            <Body>
              <Grid container>
                <Coupon />
                <OpenningHours />
                <Bio />
                <div
                  style={{
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                  }}
                >
                  {getProductsList()}
                </div>
                {/*   <ContactInfo /> */}
              </Grid>
            </Body>
            {showClubForm && <ClubForm onDismiss={() => setShowClubForm(false)} />}
            {showCoupon && <CouponForm couponImageUri={couponImageUri} onDismiss={() => setShowCoupon(false)} />}
            {showPromoMovie && <PromoVideo onDismiss={() => setShowPromoMovie(false)} />}
            {showComingSoon && renderComingSoonDialog()}
          </MuiThemeProvider>
          {/*<Arrow>⌄</Arrow>*/}
        </div>
      </ThemeProvider>
    </BusinessCardContext.Provider>
  );
}

export default BusinessCard;

const LighboxContainer = styled.div`
  display: grid;
  grid-template-rows: 5rem 3fr fit-content auto;
  font-family: ${(p) => p.theme.font};
`;

const Arrow = styled.div`
  bottom: 0;
  position: absolute;
  background-color: transparent;
  display: flex;
  justify-content: center;
  width: 100%;
  color: ${(p) => p.theme.textColor};
`;

const Body = styled.div`
  background-image: url(${(p) => p.src});
  background-size: cover;
  background-repeat: no-repeat;
`;

const StyledDialog = styled(Dialog)`
  width: ${(p) => p.theme.dimensions.vw(90)}px;
  max-height: ${(p) => p.theme.dimensions.vh(90)}px;
  padding: 0.2rem;
  overflow-y: scroll;
`;

const LightboxHeader = styled.span`
  cursor: pointer;
  grid-row: 1;
  padding: 0rem 1.75rem;
  height: 2rem;
`;
const LightboxDescription = styled.p`
  width: ${(p) => p.theme.dimensions.vw(75)}px;
  font-size: 30px;
  justify-self: center;
  margin: 0.5rem 0px;
`;
